import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateContentFromUrlMutation } from "../graphql/mutations";
import type {
  CreateContentFromUrlMutationType,
  CreateContentFromUrlMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateContentFromUrlMutation = (
  options?: MutationHookOptions<
    CreateContentFromUrlMutationType,
    CreateContentFromUrlMutationVariablesType
  >
) => {
  return useMutation<
    CreateContentFromUrlMutationType,
    CreateContentFromUrlMutationVariablesType
  >(CreateContentFromUrlMutation, options);
};
